import { Box, ChakraComponent } from '@chakra-ui/react';
import { CSSProperties } from 'react';

const sidebarStyles: CSSProperties = {
  height: '100%',
  position: 'fixed',
  zIndex: 1,
  top: 0,
  left: 0,
  overflowX: 'hidden',
};

const SideBar: ChakraComponent<'div'> = ({ children, ...props }) => {
  return (
    <Box
      as={'aside'}
      style={sidebarStyles}
      bgColor={'bg.panel'}
      borderRight={'xs'}
      borderColor={'bg.subtle'}
      backgroundColor={'black'}
      {...props}
    >
      {children}
    </Box>
  );
};

export default SideBar;
